var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSitemap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sitemap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sitemap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,23H14a3,3,0,0,0-3,3v6a3,3,0,0,0,3,3H50a3,3,0,0,0,3-3V26A3,3,0,0,0,50,23Zm1,9a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1V26a1,1,0,0,1,1-1H50a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,25H14a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H50a1,1,0,0,0,1-1V26A1,1,0,0,0,50,25ZM27,30H26a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm5.5,0h-1a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2ZM38,30H37a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,39H33V34a1,1,0,0,0-2,0v5H15a3,3,0,0,0-3,3v4a1,1,0,0,0,2,0V42a1,1,0,0,1,1-1H31v5a1,1,0,0,0,2,0V41H49a1,1,0,0,1,1,1v4a1,1,0,0,0,2,0V42A3,3,0,0,0,49,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.33,45H49.67A3.67,3.67,0,0,0,46,48.67v2.66A3.67,3.67,0,0,0,49.67,55h2.66A3.67,3.67,0,0,0,56,51.33V48.67A3.67,3.67,0,0,0,52.33,45ZM54,51.33A1.67,1.67,0,0,1,52.33,53H49.67A1.67,1.67,0,0,1,48,51.33V48.67A1.67,1.67,0,0,1,49.67,47h2.66A1.67,1.67,0,0,1,54,48.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48,
    y: 47,
    width: 6,
    height: 6,
    rx: 1.67,
    ry: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.33,45H30.67A3.67,3.67,0,0,0,27,48.67v2.66A3.67,3.67,0,0,0,30.67,55h2.66A3.67,3.67,0,0,0,37,51.33V48.67A3.67,3.67,0,0,0,33.33,45ZM35,51.33A1.67,1.67,0,0,1,33.33,53H30.67A1.67,1.67,0,0,1,29,51.33V48.67A1.67,1.67,0,0,1,30.67,47h2.66A1.67,1.67,0,0,1,35,48.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29,
    y: 47,
    width: 6,
    height: 6,
    rx: 1.67,
    ry: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.69,45H11.31A3.31,3.31,0,0,0,8,48.31v3.38A3.31,3.31,0,0,0,11.31,55h3.38A3.31,3.31,0,0,0,18,51.69V48.31A3.31,3.31,0,0,0,14.69,45ZM16,51.69A1.31,1.31,0,0,1,14.69,53H11.31A1.31,1.31,0,0,1,10,51.69V48.31A1.31,1.31,0,0,1,11.31,47h3.38A1.31,1.31,0,0,1,16,48.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10,
    y: 47,
    width: 6,
    height: 6,
    rx: 1.31,
    ry: 1.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,7H10a3,3,0,0,0-3,3v2a3,3,0,0,0,3,3H36a3,3,0,0,0,3-3V10A3,3,0,0,0,36,7Zm1,5a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1H36a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,18a1,1,0,0,1-1,1H4a1,1,0,0,1,0-2H60A1,1,0,0,1,61,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,3H6A3,3,0,0,0,3,6V58a3,3,0,0,0,3,3H58a3,3,0,0,0,3-3V6A3,3,0,0,0,58,3Zm1,55a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H58a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,5H6A1,1,0,0,0,5,6V17H59V6A1,1,0,0,0,58,5ZM39,12a3,3,0,0,1-3,3H10a3,3,0,0,1-3-3V10a3,3,0,0,1,3-3H36a3,3,0,0,1,3,3Zm4,1a2,2,0,1,1,2-2A2,2,0,0,1,43,13Zm6,0a2,2,0,1,1,2-2A2,2,0,0,1,49,13Zm6,0a2,2,0,1,1,2-2A2,2,0,0,1,55,13Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitemap);
export default __webpack_public_path__ + "static/media/sitemap.c2452520.svg";
export { ForwardRef as ReactComponent };